import config from "./config";
import apiService from "./apiService";
export default {
  async getRiskProfileData(companyid, adviserid, clientid) {
    let clientApiUrl = `${config.riskprofileurl}/${clientid}/${adviserid}/${companyid}`;
    return apiService.get(clientApiUrl);
  },
};
